module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/maps"
    }
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Foreword, by Tyler Resch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNINGTON")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPEDITION")]), _vm._v(": A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h1"
    }
  }, [_vm._v("Background")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h2"
    }
  }, [_vm._v("Overview of Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h3"
    }
  }, [_vm._v("Raising Troops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLE OF")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNINGTON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Description of Battlefield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gregg’s Skirmish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nichols’s Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herrick’s Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Tory Redoubt”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diversion in the Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fight with Breymann")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCOUNTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loyalists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cattle Ambush on the Hoosic River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civilians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/aftermath",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A. Commemoration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B. Bennington Expedition Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C. Key Personalities Appearing in the Accounts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0